import Excel from 'exceljs';
import { saveAs } from 'file-saver';

const excelColumns = [
  {
    accessorKey: 'provider_id',
    header: 'Provider ID',
    key: 'provider_id',
    columnFilterModeOptions: ['contains'],
  },
  {
    accessorKey: 'provider_name',
    header: 'Provider Name',
    key: 'provider_name',
    columnFilterModeOptions: ['contains'],
  },
  {
    accessorKey: 'formatted_address',
    header: 'Address',
    key: 'formatted_address',
    columnFilterModeOptions: ['contains'],
  },
  {
    accessorKey: 'city',
    header: 'City',
    key: 'city',
  },
  {
    accessorKey: 'state',
    header: 'State',
    key: 'state',
  },
  {
    accessorKey: 'country',
    header: 'Country',
    key: 'country',
  },
  {
    accessorKey: 'zipPostal',
    header: 'Zipcode',
    key: 'zipPostal',
  },

  {
    accessorKey: 'product_type',
    header: 'Product Type',
    key: 'product_type',
  },

  {
    accessorKey: 'floor_amenities',
    header: 'Amenities',
    key: 'floor_amenities',
  },
  {
    accessorKey: 'provider_contact_email',
    header: 'Provider Contact Email',
    key: 'provider_contact_email',
  },
  {
    accessorKey: 'region',
    header: 'Region',
    key: 'region',
  },
  {
    accessorKey: 'source_system',
    header: 'Source',
    key: 'source_system',
  },
  {
    accessorKey: 'coordinates',
    header: 'Coordinates',
    key: 'coordinates',
  },
  {
    accessorKey: 'createdBy',
    header: 'Created By',
    key: 'createdBy',
  },
  {
    accessorKey: 'provider_created_date',
    header: 'Created Date',
    key: 'provider_created_date',
  },
  {
    accessorKey: 'updatedBy',
    header: 'Updated By',
    key: 'updatedBy',
  },
  {
    accessorKey: 'provider_updated_date',
    header: 'Updated Date',
    key: 'provider_updated_date',
  },
  {
    accessorKey: 'picture_path',
    header: 'Images',
    key: 'picture_path',
  },
];

export const saveExcel = async (downloadDataArray, providerName) => {
  const workbook = new Excel.Workbook();
  const workSheetName = 'Worksheet-1';

  try {
    const workBookName = 'ProviderLocations';
    // setDownloadLoading(false);

    const fileName = providerName + '_' + workBookName;

    const worksheet = workbook.addWorksheet(workSheetName);

    worksheet.columns = excelColumns;
    worksheet.getRow(1).font = { bold: true };

    worksheet.columns.forEach((column) => {
      column.width = column.header?.length + 5;
      column.alignment = { horizontal: 'center' };
    });

    downloadDataArray.forEach((locData) => {
      const emailContacts =
        locData && locData.provider_contact_info
          ? locData.provider_contact_info.map((s) => s.email)
          : [];

      locData.provider_contact_email = emailContacts?.toString().replace(/^,|,$/g, '');

      if (locData?.['source_system']) {
        locData.source_system = locData?.['source_system'][0];
      }

      if (locData?.['coordinates']) {
        let coordinatesString;

        if (typeof locData.coordinates === 'object') {
          coordinatesString = JSON.stringify(locData.coordinates);
        } else {
          coordinatesString = locData.coordinates;
        }

        locData.coordinates = coordinatesString
          .replace(/[{}"]/g, '')
          .replace(/:/g, ': ')
          .replace(/,/g, ', ');
      }

      if (locData?.['floor_picture_path']) {
        locData.picture_path = locData?.['floor_picture_path'];
      }
    });

    downloadDataArray.forEach((singleData) => {
      worksheet.addRow(singleData);
    });

    worksheet.eachRow({ includeEmpty: false }, (row) => {
      const currentCell = row._cells;

      currentCell.forEach((singleCell) => {
        const cellAddress = singleCell._address;

        worksheet.getCell(cellAddress).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    });

    const buf = await workbook.xlsx.writeBuffer();

    saveAs(new Blob([buf]), `${fileName}.xlsx`);
  } catch (error) {
    console.error('Failed to download excel', error);
  } finally {
    workbook.removeWorksheet(workSheetName);
  }
};
